var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9225 8.5H6.0775L5.5 6.83687L4.9225 8.5ZM11 8C10.5866 8 10.25 8.33656 10.25 8.75C10.25 9.16344 10.5866 9.5 11 9.5C11.4134 9.5 11.75 9.16344 11.75 8.75C11.75 8.33656 11.4134 8 11 8ZM14.5 2H1.5C0.671875 2 0 2.67188 0 3.5V12.5C0 13.3281 0.671875 14 1.5 14H14.5C15.3281 14 16 13.3281 16 12.5V3.5C16 2.67188 15.3281 2 14.5 2ZM7.83063 11H7.30125C7.08844 11 6.89875 10.865 6.82875 10.6641L6.59844 10H4.40188L4.17125 10.6641C4.13716 10.7622 4.07334 10.8473 3.98866 10.9075C3.90398 10.9677 3.80265 11 3.69875 11H3.16937C2.82531 11 2.58406 10.6609 2.69688 10.3359L4.375 5.50375C4.42613 5.3566 4.52182 5.22902 4.64877 5.13874C4.77573 5.04847 4.92766 4.99997 5.08344 5H5.91656C6.07239 4.99997 6.22435 5.0485 6.35132 5.13884C6.47828 5.22918 6.57395 5.35684 6.625 5.50406L8.30281 10.3359C8.41562 10.6609 8.17438 11 7.83063 11ZM13.25 10.5C13.25 10.7762 13.0262 11 12.75 11H12.25C12.0984 11 11.9675 10.9291 11.8756 10.8225C11.6062 10.9369 11.3103 11 11 11C9.75937 11 8.75 9.99062 8.75 8.75C8.75 7.50938 9.75937 6.5 11 6.5C11.2644 6.5 11.5144 6.55406 11.75 6.63812V5.5C11.75 5.22375 11.9738 5 12.25 5H12.75C13.0262 5 13.25 5.22375 13.25 5.5V10.5Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeas);
export default __webpack_public_path__ + "static/media/ideas.54113c43be5cb22c50db4af71a4e7e73.svg";
export { ForwardRef as ReactComponent };